import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSpotlight from './components/FeaturedSpotlight';
import TrendingGrid from './components/TrendingGrid';
import DownloadCTA from './components/DownloadCTA';
import CategoryGrid from './components/CategoryGrid';
import StatsSection from './components/StatsSection';
import LatestNews from './components/LatestNews';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '51app',
      url: 'http://lalaccu.cn/',
      logo: 'http://lalaccu.cn/logo.png',
      description: '全网最热门的吃瓜爆料平台，第一时间获取网红八卦、明星绯闻、聊天记录曝光、视频爆料。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-5151',
        contactType: 'customer service',
        areaServed: 'CN',
        availableLanguage: 'Chinese',
      },
      sameAs: [
        'http://lalaccu.cn/',
      ],
    },
    {
      '@type': 'WebSite',
      name: '51app',
      url: 'http://lalaccu.cn/',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://lalaccu.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'http://lalaccu.cn/',
      url: 'http://lalaccu.cn/',
      name: '51app - 全网吃瓜爆料第一站',
      description: '免费下载安装51app，获取今日最热网红爆料、明星八卦、聊天记录曝光、视频爆料。全网吃瓜内容实时更新。',
      isPartOf: { '@id': 'http://lalaccu.cn/' },
      about: {
        '@type': 'Thing',
        name: '网络爆料',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '51app 是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '51app 是国内领先的吃瓜爆料资讯平台，专注于收集和整理全网最热门的网红爆料、明星八卦、聊天记录曝光、视频爆料等内容。',
          },
        },
        {
          '@type': 'Question',
          name: '51app 收费吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '51app 下载和使用完全免费。所有资讯内容均可免费阅读观看，不设置任何付费墙。',
          },
        },
        {
          '@type': 'Question',
          name: '如何下载安装 51app？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以在本网站首页点击"立即下载"按钮，或者扫描页面上的二维码进行下载。51app 支持 iOS 和 Android 双平台，下载完全免费。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="51app - 全网吃瓜爆料第一站 | 免费下载安装"
        description="免费下载安装51app，获取今日最热网红爆料、明星八卦、聊天记录曝光、视频爆料。全网吃瓜内容实时更新，让你永远站在吃瓜最前线。51app，免费app，吃瓜爆料，网红丑闻，明星绯闻。"
        keywords="51app,免费app,吃瓜爆料,网红丑闻,明星八卦,聊天记录曝光,视频爆料,51app下载,林迪app,快手app,今日吃瓜"
        canonical="/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSpotlight />
        <TrendingGrid />
        <CategoryGrid />
        <LatestNews />
        <StatsSection />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}
